import * as React from "react";
import { SVGProps, memo } from "react";

const SvgGrayCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg width={26} height={25} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 22.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Zm4.352-11.582a.938.938 0 0 0-1.326-1.326l-3.957 3.957-2.094-2.095a.938.938 0 0 0-1.326 1.326l2.536 2.537a1.25 1.25 0 0 0 1.768 0l4.399-4.4Z"
      fill="#D3DDE8"
    />
  </svg>
);

const Memo = memo(SvgGrayCheck);

export default Memo;
